var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoadRollerHighlighted({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29440",
    "data-name": "Group 29440",
    transform: "translate(-288 -582.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(288 582.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-17_14_",
    "data-name": "svgexport-17 (14)",
    transform: "translate(303 591.248)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50522",
    "data-name": "Path 50522",
    d: "M153.262,260.732a.32.32,0,0,1-.324-.324v-1.993l-1.165-.841a.307.307,0,0,1-.129-.194.344.344,0,0,1,.052-.246l.815-1.087a.312.312,0,0,1,.427-.078l1.851,1.346a.318.318,0,0,1,.129.259l.013,2.847a.31.31,0,0,1-.324.311Z",
    transform: "translate(-149.664 -255.917)",
    fill: "#99a4ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50523",
    "data-name": "Path 50523",
    d: "M252.324,558.906a.32.32,0,0,1-.324-.324V558h1.993v.6a.31.31,0,0,1-.324.311Z",
    transform: "translate(-248.726 -554.09)",
    fill: "#8a949b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50524",
    "data-name": "Path 50524",
    d: "M140.324,580.511a.32.32,0,0,1-.324-.324v-.945A1.24,1.24,0,0,1,141.229,578h3.145a.324.324,0,1,1,0,.647l.129,1.773a.619.619,0,0,0-.621.608l-3.236-.815A.307.307,0,0,1,140.324,580.511Z",
    transform: "translate(-138.175 -573.832)",
    fill: "#ffab00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50525",
    "data-name": "Path 50525",
    d: "M.993,299.062H-.676A.329.329,0,0,1-1,298.738v-5.151a.953.953,0,0,1,.3-.673.954.954,0,0,1,.712-.259l4.879.052V288A1,1,0,0,1,5.9,287h8.166a.325.325,0,0,1,.3.207l2.084,5.863a.372.372,0,0,1-.039.285.291.291,0,0,1-.259.116h-.194l-5.267,5.06a.312.312,0,0,1-.22.518L7,299.062a.326.326,0,0,1-.324-.311H1.3A.307.307,0,0,1,.993,299.062Z",
    transform: "translate(1 -286.598)",
    fill: "#ffd300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50526",
    "data-name": "Path 50526",
    d: "M131.326,943.652a3.326,3.326,0,1,1,3.326-3.326A3.342,3.342,0,0,1,131.326,943.652Z",
    transform: "translate(-126.33 -928.185)",
    fill: "#464f5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50527",
    "data-name": "Path 50527",
    d: "M503,339.112l10.185.116L511.335,334H503.4a.371.371,0,0,0-.388.375v4.737Z",
    transform: "translate(-496.477 -332.989)",
    fill: "#ffab00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50528",
    "data-name": "Path 50528",
    d: "M214.239,1025.478a2.239,2.239,0,1,1,2.252-2.239A2.267,2.267,0,0,1,214.239,1025.478Z",
    transform: "translate(-209.243 -1011.098)",
    fill: "#6a717c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50529",
    "data-name": "Path 50529",
    d: "M654.682,874.7h-1.359a.324.324,0,0,1,0-.647h1.359a.32.32,0,0,1,.323.324A.329.329,0,0,1,654.682,874.7Zm0-1.048h-1.359a.32.32,0,0,1-.324-.324.329.329,0,0,1,.324-.324h1.359a.324.324,0,0,1,0,.647Z",
    transform: "translate(-644.536 -865.014)",
    fill: "#ffab00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50530",
    "data-name": "Path 50530",
    d: "M539.941,409.119h-1.618A.32.32,0,0,1,538,408.8v-2.407a.318.318,0,0,1,.324-.311h1.618a.326.326,0,0,1,.324.311v2.433A.357.357,0,0,1,539.941,409.119Zm6.277.065h-4.905a.329.329,0,0,1-.323-.324v-2.226a.644.644,0,0,1,.634-.634h3.663a.3.3,0,0,1,.285.22l.919,2.55a.323.323,0,0,1-.039.285A.246.246,0,0,1,546.218,409.184Z",
    transform: "translate(-531.024 -404.058)",
    fill: "#92ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50531",
    "data-name": "Path 50531",
    d: "M310.971,1120.954a.961.961,0,0,1-.971-.971.98.98,0,0,1,.971-.984.992.992,0,0,1,.984.984A.98.98,0,0,1,310.971,1120.954Z",
    transform: "translate(-305.975 -1107.83)",
    fill: "#2e343d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50532",
    "data-name": "Path 50532",
    d: "M1020.14,747.228a4.58,4.58,0,0,1-4.284-2.938.3.3,0,0,1,.181-.4c.013-.013.026-.013.052-.026l.116-2.562a.279.279,0,0,1-.142-.026.315.315,0,0,1-.168-.414,4.612,4.612,0,0,1,8.878,1.747A4.634,4.634,0,0,1,1020.14,747.228Z",
    transform: "translate(-1002.668 -731.761)",
    fill: "#464f5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50533",
    "data-name": "Path 50533",
    d: "M1107.755,825.144a3.537,3.537,0,0,1-3.119-1.851.3.3,0,0,1,.13-.427.225.225,0,0,1,.181-.039l-.052-2.576a.219.219,0,0,1-.129-.039.334.334,0,0,1-.117-.44,3.579,3.579,0,1,1,3.106,5.371Z",
    transform: "translate(-1090.283 -810.726)",
    fill: "#6a717c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50534",
    "data-name": "Path 50534",
    d: "M865.118,944.87h-6.794a.32.32,0,0,1-.324-.324v-3.223a.329.329,0,0,1,.324-.323h6.769a1.935,1.935,0,0,1,.026,3.87Z",
    transform: "translate(-846.883 -932.134)",
    fill: "#99a4ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50535",
    "data-name": "Path 50535",
    d: "M1271.022,1017.045a1.033,1.033,0,0,1-1.022-1.022,1.016,1.016,0,0,1,1.022-1.022,1.022,1.022,0,0,1,0,2.045Z",
    transform: "translate(-1253.551 -1005.176)",
    fill: "#2e343d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadRollerHighlighted);
export default __webpack_public_path__ + "static/media/roadRollerHighlighted.6a12a6b98d8e2bc40cdbd52b355c04e9.svg";
export { ForwardRef as ReactComponent };